import { useCallback, useEffect, useState } from "react";
import { RouterProvider, useParams } from "react-router";

import { ConfigProvider, message, theme } from "antd";
import enUS from "antd/locale/en_US";
import frFR from "antd/locale/fr_FR";
import deDE from "antd/locale/de_DE";
import itIT from "antd/locale/it_IT";
import esES from "antd/locale/es_ES";
import nlNL from "antd/locale/nl_NL";
import plPL from "antd/locale/pl_PL";
import csCZ from "antd/locale/cs_CZ";
import { useAppDispatch, useAppSelector } from "./store/hooks";
import { getCSSByPalette, getSkinConfigByUnivers } from "./styles/skin";
import dayjs from "dayjs";
import "dayjs/locale/fr";
import "dayjs/locale/de";
import "dayjs/locale/it";
import "dayjs/locale/es";
import "dayjs/locale/nl";
import "dayjs/locale/pl";
import "dayjs/locale/cs";
import "dayjs/locale/zh-cn";

const antdLocaleMap: Record<string, typeof frFR> = {
  fr: frFR,
  en: enUS,
  de: deDE,
  it: itIT,
  es: esES,
  nl: nlNL,
  pl: plPL,
  cs: csCZ,
};

const dayjsLocaleMap: Record<string, string> = {
  fr: "fr",
  en: "en",
  de: "de",
  it: "it",
  es: "es",
  nl: "nl",
  pl: "pl",
  cs: "cs",
  zh: "zh-cn",
  "zh-cn": "zh-cn",
};

import { router } from "./pages/router";
import { getAppToken, getMemAppToken } from "utils/helpers/project";
import { useAuth } from "utils/hooks/useAuth";
import Loader from "components/shared/loader";
import { setSkinConfig } from "store/componentsSlice";
import { getDefaultNetwork } from "utils/defines";

const getNetworkFromUrl = (networkCode: string) => {
  let _network = getDefaultNetwork();
  switch (networkCode) {
    case "ATLFR":
      _network = "ATLFR";
      break;
    case "ACVFR":
      _network = "ACVFR";
      break;
    case "YGNBE":
      _network = "YGNBE";
      break;
    case "YGNIT":
      _network = "YGNIT";
      break;
    case "ACVES":
      _network = "ACVES";
      break;
    case "ACVUK":
      _network = "ACVUK";
      break;
    case "HAMUK":
      _network = "HAMUK";
      break;
    case "ACVGABe":
      _network = "ACVGABe";
      break;
    case "IDEAL":
      _network = "IDEAL";
      break;
    case "ACVPL":
      _network = "ACVPL";
      break;
    case "ACVDE":
      _network = "ACVDE";
      break;
    case "ACVCZ":
      _network = "ACVCZ";
      break;
    case "ACVIT":
      _network = "ACVIT";
      break;
    case "ATLPOL":
      _network = "ATLPOL";
      break;
  }

  return _network;
}

const getBrandByNetwork = (networkCode: string) => {
  let _brand = "atlantic";
  switch (networkCode) {
    case "ATLFR":
    case "ACVFR":
      _brand = "atlantic";
      break;
    case "YGNBE":
    case "YGNIT":
      _brand = "ygnis";
      break;
    case "ACVES":
    case "ACVUK":
    case "ACVGABe":
    case "ACVPL":
    case "ACVDE":
    case "ACVCZ":
    case "ACVIT":
    case "ATLPOL":
      _brand = "acv";
      break;
    case "HAMUK":
      _brand = "hamworthy";
      break;
    case "IDEAL":
      _brand = "ideal";
      break;
  }

  return _brand;
}

const AppDefault: React.FC<{ isTokenLoaded: boolean }> = (isTokenLoaded) => {
  const skinConfig = useAppSelector((state) => state.components.skinConfig);
  const mode = useAppSelector((state) => state.components.mode);
  const [isDarkMode, setIsDarkMode] = useState(false);

  // function viewportHandler(event: any) {
  //   // NOTE: This doesn't actually work at time of writing
  //   console.log(event.target.scale);
  //   if (event.target.scale > 3) {
  //     document.body.classList.remove("hide-text");
  //   } else {
  //     document.body.classList.add("hide-text");
  //   }
  // }

  const onChange = useCallback(() => {
    const pr = window.devicePixelRatio;
    const media = `(resolution: ${pr}dppx)`;
    const mql = matchMedia(media);

    //const prString = (pr * 100).toFixed(0);

    //const hardPercent = 1920 / screen.width * 100 - 100;

    //const hp = 1920 / screen.width;
    //const browserPercent = pr * 100 - hardPercent - 100;

    //const textContent = `${prString}% (${pr.toFixed(2)}) - (${hp.toFixed(2)})`;

    //console.log(textContent);
    //console.log(screen.width)

    const hp = screen.width / 1920;
    const coef = screen.width / screen.height;
    //console.log(hp)

    //document.body.style.zoom = ((100 - browserPercent) as number) + "%";

    //document.body.style.zoom = ((hp/pr * 100) as number) + "%";
    if (window.navigator.userAgent.includes("Mac OS")) {
      //document.body.style.zoom = ((2 / pr) * 100 as number) + "%";
    } else if (window.navigator.userAgent.includes("Firefox")) {
      document.body.style.zoom = (((1 / pr) * 100) as number) + "%";
    } else {
      if (hp >= 1 && coef < 2) {
        document.body.style.zoom = (((hp / pr) * 100) as number) + "%";
      } else {
        //document.body.style.zoom = ((1 / pr) * 100 * (1 + hp) as number) + "%";
        document.body.style.zoom = (((1 / pr) * 100) as number) + "%";
      }
    }

    mql.addEventListener("change", onChange, { once: true });
  }, []);

  useEffect(() => {
    message.config({
      top: 0,
      duration: 5,
      maxCount: 3,
      prefixCls: "antd-message",
    });

    //window.visualViewport?.addEventListener("resize", viewportHandler);

    //onChange();
  }, []);

  useEffect(() => {
    if (mode === "auto") {
      const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
      setIsDarkMode(mediaQuery.matches);

      const handleChange = (event: MediaQueryListEvent) => {
        setIsDarkMode(event.matches);
      };

      mediaQuery.addEventListener("change", handleChange);

      return () => {
        mediaQuery.removeEventListener("change", handleChange);
      };
    } else {
      setIsDarkMode(mode === "dark");
    }
  }, [mode]);

  useEffect(() => {
    document.documentElement.classList.toggle("dark-mode", isDarkMode);
  }, [isDarkMode]);

  const {
    sizeConfig: { fontSize, fontFamily },
    colorPalette,
  } = skinConfig;

  const algorithm = isDarkMode ? theme.darkAlgorithm : undefined;

  const lang = useAppSelector((state) => state.common.lang);
  const normalizedLang = (lang || "fr").toLowerCase();
  const antdLocale = antdLocaleMap[normalizedLang] || frFR;

  useEffect(() => {
    dayjs.locale(dayjsLocaleMap[normalizedLang] || "fr");
  }, [normalizedLang]);

  return (
    <>
      <style>
        {getCSSByPalette(colorPalette, fontFamily, fontSize as any)}
      </style>

      <ConfigProvider
        locale={antdLocale}
        theme={{
          algorithm,
          token: {
            colorLink: colorPalette.colorPrimary,
            colorLinkActive: colorPalette.colorDark,
            colorLinkHover: colorPalette.colorLight,
            motionDurationMid: "0s",
            motionDurationSlow: "0s",
            motionDurationFast: "0s",
            motion: false,
            //  borderRadiusLG: 5,

            //  borderRadiusOuter: 5,
            lineHeight: 1.2,
            borderRadius: 3,
            colorPrimary: colorPalette.colorPrimary,
            sizeStep: 3,
            sizeUnit: 3,
            fontSize,
            fontFamily,
            fontSizeLG: fontSize,
            paddingXXS: 3,
            //    paddingSM:3,
            marginXXS: 3,
            boxShadow:
              "0 0 15px 2px rgba(0, 0, 0, 0.1), 0 0 0 1px rgba(0, 0, 0, 0.05)",
            boxShadowSecondary:
              "0 0 15px 2px rgba(0, 0, 0, 0.1), 0 0 0 1px rgba(0, 0, 0, 0.05)",
          },
          components: {
            Notification: {
              motionDurationMid: ".125s",
              motionDurationSlow: ".125s",
              motionDurationFast: ".125s",
              borderRadiusLG: 10,
            },
            Message: {
              contentPadding: 5,
            },
            Select: {
              controlHeightLG: 42,
              // paddingSM: 10,
              paddingXS: 5,
              singleItemHeightLG: 42,
              controlPaddingHorizontalSM: 5,
              controlPaddingHorizontal: 10,
            },
          },
        }}
      >
        {isTokenLoaded ? <RouterProvider router={router}
        //future={{v7_startTransition: true}}
        /> : <Loader />}
      </ConfigProvider>
    </>
  );
};

const App: React.FC = () => {
  const [isTokenLoaded, setIsTokenLoaded] = useState<boolean>(false);
  const skinConfig = useAppSelector((state) => state.components.skinConfig);
  const dispatch = useAppDispatch();
  const params = useParams();

  const { logout } = useAuth();

  const {
    sizeConfig: { fontSize, fontFamily },
    colorPalette,
  } = skinConfig;

  useEffect(() => {
    if (!isTokenLoaded) {
      const app_token = getMemAppToken();
      if (!app_token) {
        getAppToken((result: any) => {
          if (result) {
            setIsTokenLoaded(true);
          }
        });
      } else {
        setIsTokenLoaded(true);
      }
    }
  }, []);


  useEffect(() => {
    const handleStorageChange = (event: StorageEvent) => {
      if (event.key === "accessToken") {
        if (!event.newValue) {
          logout();
        } else if (event.oldValue) {
          window.location.reload();
        }
      }
    };

    window.addEventListener("storage", handleStorageChange);

    const brand = getBrandByNetwork(getNetworkFromUrl(params.network?.toLowerCase() as string));
    dispatch(setSkinConfig(getSkinConfigByUnivers(brand || "")));

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);


  if (!isTokenLoaded) {
    return <>
      <style>
        {getCSSByPalette(colorPalette, fontFamily, fontSize as any)}
      </style>
      <Loader />
    </>;
  }

  return (
    <>
      <AppDefault isTokenLoaded={isTokenLoaded} />
    </>
  );
};
export default App;
